<template lang="pug">
  .basic-experience-and-awards
    .basic-experience-and-awards__experience
      .basic-experience-and-awards__title {{ $t('服务经验最多 Top 3') }} :
      .basic-experience-and-awards__experience__item(
        v-for="(item, m) in experienceInfo"
        :key="m"
      )
        span {{ $t(experienceInfo[m].industry_name) }}
        span {{ experienceInfo[m].client_name }}
    .basic-experience-and-awards__awards
      .basic-experience-and-awards__title {{ $t('获奖情况') }} :
      .basic-experience-and-awards__awards__item(
        v-for="(item,n) in data.award"
        :key="n"
      )
        span {{ item.award_name }}
        span(@click="show(item.download_url)")
          i.iconfont.icon-show
          span {{ $t('查看') }}
    el-dialog.basic-experience-and-awards__dialog(
      :visible.sync="showDialog"
      :close-on-click-modal="false"
    )
      img(
        :src="viewImg.url"
        :class="{ widthFixed: viewImg.width/viewImg.height >= 1, heightFixed: viewImg.width/viewImg.height < 1 }",
      )
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    experienceInfo: {
      type: Array,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      showDialog: false,
      viewImg: {
        url: null,
        width: null,
        height: null
      }
    }
  },
  methods: {
    show (url) {
      const self = this
      this.viewImg.url = url
      let img = new Image()
      img.src = url
      img.addEventListener('load', function () {
        self.viewImg.height = this.naturalHeight
        self.viewImg.width = this.naturalWidth
        self.showDialog = true
      })
    }
  }
}
</script>

<style lang="stylus">
.basic-experience-and-awards
  padding-left 100px
  margin-bottom 18px

.basic-experience-and-awards__title
  font-weight 600
  margin-bottom 20px

.basic-experience-and-awards__experience
  margin-bottom 40px

.basic-experience-and-awards__experience__item
  margin-bottom 10px
  > span:nth-child(1)
    display: inline-block
    width: 150px
  > span:nth-child(1)::before
    content: ""
    height 8px
    width 8px
    border-radius 4px
    background-color $main
    display inline-block
    margin-right 10px

.basic-experience-and-awards__awards__item
  margin-bottom 10px
  > span:nth-child(1)
    display inline-block
    min-width 200px
    margin-right 10px
  > span:nth-child(2)
    color $main
    cursor pointer
    > i
      margin-right 10px

.basic-experience-and-awards__dialog
  .el-dialog
    width 500px
  .el-dialog__body
    display flex
    justify-content center
    align-items center
    .widthFixed
      width 400px
    .heightFixed
      height 400px
</style>
